import { connect } from "react-redux";
import { confirmNewAccount } from "../../../../domain/validation/validationActions";
import { login } from "../../../../domain/auth/authActions";
import { openModal, closeModal } from "../../../../domain/ui/uiActions";
const mapStateToProps = (state) => ({
    authError: state.auth.error,
    authFieldErrors: state.auth.fieldErrors,
    authIsLoading: state.auth.isLoading,
    authIsSuccess: state.auth.isSuccess,
    isForgotPasswordRateLimited: state.auth.isForgotPasswordRateLimited,
    isPasswordResetSuccess: state.auth.isPasswordResetSuccess,
    isSuccessLogout: state.auth.isSuccessLogout,
    validationError: state.validation.error,
    validationFieldErrors: state.validation.fieldErrors,
    validationIsLoading: state.validation.isLoading
});
const bindActionsToProps = {
    closeModal,
    confirmNewAccount,
    login,
    openModal
};
/* Create and export container component that wraps Login for property binding */
export default connect(mapStateToProps, bindActionsToProps);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Login/connect.ts